<template>
  <div class="videoMsg v-video">
    <div @click="openVideo(data.filePath)">
      <a href='#'>
        <img :src="data.previewImageUrl" />
      </a>
    </div>
  </div>
</template>

<script>
import Global from "@/components/Global";

export default {
  props: ["data"],
  data() {
    return {};
  },
  computed: {},
  methods: {
    openVideo(url)
    {
       window.open(url);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Main/ChatMessageVedio.vue